import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";

// props
interface IProps{
	value?: any
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterPercentage',
  props: {
    value: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	value?: any
};



// computed
const isInvalid = computed<boolean>(
	() => percent.value < 0 || percent.value > 100
);

// data
const percent = ref<number>(props.value ?? 0);

// expose
expose({ isInvalid });

return { __sfc: true,props, isInvalid, percent }
}

})